<script lang="ts">
	import { VideoPlayer } from '../../../../components/VideoPlayer';
	import { extractNonNull } from '../../../../utils/extractNonNull/extractNonNull';
	import type { ArticleVideoType } from '../../types';

	interface Props {
		item: ArticleVideoType;
		title: string;
	}

	let { item, title }: Props = $props();

	let safeItem = $derived(extractNonNull(item, ['link'], {}));
</script>

{#if safeItem}
	<VideoPlayer
		controls
		src={safeItem?.link}
		title={safeItem.legend || title}
		dataCy="blog-article"
		class="pb-[56.25%]"
	/>
{/if}
